import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { onAttributeSearch } from "../../controller/AttributeController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table, Pagination, Badge } from 'react-bootstrap';
import { Page } from "../../dto/page/Page";
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import { AttributeSearch } from "../../dto/attribute/AttributeSearch";
import { AttributeListEntity } from "../../dto/attribute/AttributeListEntity";
import { AttributeEntity } from "../../dto/attribute/AttributeEntity";
import { getAttributeDataType, getAttributeStatus, getYesNo } from "../../app/AppConst";

const AttributeList = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        }
    }, [])

    const [search, setSearch] = useState<AttributeSearch>({
        limit: 10
    });
    const [attributes, setAttributes] = useState<AttributeListEntity>({
        data: []
    });

    // ---- Search submit
    const searchSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        load(0); // reset to first page on new search
    };

    // ---- Pagination click
    const changePage = (page: number) => {
        if (!attributes.page) return;
        if (page < 0 || page >= attributes.page.totalPages) return;
        load(page);
    };

    const load = async (page: number = 0) => {
        const params: AttributeSearch = {
            ...search,
            offset: page
        };

        const response = await onAttributeSearch(params);

        if (response.status !== 0) {
            toast.error("Атрибут уншихад алдаа гарлаа");
            return;
        }

        const pageable = response.data;

        const pageInfo: Page = {
            limit: search.limit,
            totalElements: pageable.totalElements,
            totalPages: pageable.totalPages,
            offset: page
        };

        const beans: Array<AttributeEntity> = pageable.beans;

        setAttributes({
            page: pageInfo,
            data: beans
        });

        setSearch(prev => ({ ...prev, offset: page }));
    };

    return (
        <Container fluid>
            <div><Toaster position="top-right" reverseOrder={false}/></div>
            <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Атрибут</h3>
            <Row className="d-flex justify-content-center align-items-center mb-3">
                <Col md={12} lg={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <Form onSubmit={searchSubmit}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="name">
                                            <Form.Label className="text-center">
                                                Нэр
                                            </Form.Label>
                                            <Form.Control size="sm" type="text" 
                                            onChange={(event) => {
                                                const value = event.target.value;
                                                if (value !== "") {
                                                    setSearch({
                                                        ...search,
                                                        name: event.target.value
                                                    })
                                                } else {
                                                    const { name, ...rest } = search;
                                                    setSearch(rest);
                                                }
                                            }} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="offSet">
                                            <Form.Label>Багцлах</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select size="sm"
                                                    onChange={(event) => setSearch({
                                                        ...search,
                                                        limit: parseInt(event.target.value)
                                                    })}>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="0">Бүгд</option>
                                                </Form.Select>
                                                <Button variant="primary" size="sm" type="submit">
                                                    <SearchIcon fontSize="small"/>
                                                </Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Header>
                        <Card.Body>
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Код</th>
                                        <th>Нэр</th>
                                        <th>Өгөгдөл </th>
                                        <th>UI</th>
                                        <th>Статус</th>
                                        <th>Баталгаажуулах</th>
                                        <th>Сонголтууд</th>
                                        <th><InfoIcon /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attributes.data.length === 0 && (
                                        <tr>
                                            <td className="text-muted">
                                                Илэрц олдсонгүй
                                            </td>
                                        </tr>
                                    )}
                                    {
                                        attributes.data.map((data, idx) => {
                                            return (
                                                <tr key={idx}>
                                                    <td>{data.code}</td>
                                                    <td>{data.name}</td>
                                                    <td>
                                                        <Badge bg={getAttributeDataType(data.dataType)}>{data.dataType}</Badge>
                                                    </td>
                                                    <td>
                                                        <Badge bg={getAttributeDataType(data.uiType)}>{data.uiType}</Badge>
                                                    </td>
                                                    <td>
                                                        <Badge bg={getAttributeStatus(data.status)}>{data.status}</Badge>
                                                    </td>
                                                    <td>
                                                        <Badge bg={getYesNo(data.verificationRequired)}>{data.verificationRequired ? "YES" : "NO"}</Badge>
                                                    </td>
                                                    <td style={{ overflow: "auto" }}>
                                                        <ul style={{ maxHeight: "200px" }}>
                                                            {
                                                                data.choices &&
                                                                data.choices.map((choice, choiceIdx) => {
                                                                    return (
                                                                        <li key={choiceIdx}>
                                                                            <p>{choice.valueText}</p>
                                                                            <br/>
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </td>
                                                    <th><a href={`/attribute/${data.id}`}><InfoIcon /></a></th>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>  
            </Row>

            {attributes.page && attributes.page.totalPages > 1 && (() => {
                const page = attributes.page;   // now TypeScript knows it's NOT undefined

                return (
                    <Row>
                        <Col className="d-flex justify-content-start">
                            <Pagination>
                                <Pagination.First
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(0)}
                                />

                                <Pagination.Prev
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(page.offset - 1)}
                                />

                                {Array.from({ length: page.totalPages })
                                    .slice(
                                        Math.max(page.offset - 2, 0),
                                        Math.min(page.offset + 3, page.totalPages)
                                    )
                                    .map((_, idx) => {
                                        const pageNumber =
                                            Math.max(page.offset - 2, 0) + idx;

                                        return (
                                            <Pagination.Item
                                                key={pageNumber}
                                                active={pageNumber === page.offset}
                                                onClick={() => changePage(pageNumber)}
                                            >
                                                {pageNumber + 1}
                                            </Pagination.Item>
                                        );
                                    })}

                                <Pagination.Next
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.offset + 1)}
                                />

                                <Pagination.Last
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.totalPages - 1)}
                                />
                            </Pagination>
                        </Col>
                    </Row>
                );
            })()}
        </Container>
    )
}

export default AttributeList;